import type { DynamicInvoiceMeasurementChartData } from '@weft/api-definition';
import type { CommitmentLineItem, LINE_ITEM_TYPES, UsageLineItem } from '@weft/types';
import React from 'react';
import { DynamicInvoiceProductLineItem } from '../dynamic-invoice-product-line-item/DynamicInvoiceProductLineItem';
import { DynamicInvoiceViewSection } from '../DynamicInvoiceViewSection';

export type UsageLineItemsSectionProps = {
  customerId: string;
  title: string;
  commitmentLineItems: (CommitmentLineItem & { type: typeof LINE_ITEM_TYPES.Commitment })[];
  usageLineItems: (UsageLineItem & { type: typeof LINE_ITEM_TYPES.Usage })[];
  measurementChartData: DynamicInvoiceMeasurementChartData;
  invoiceId: string;
};

export const UsageLineItemsSection: React.FC<UsageLineItemsSectionProps> = ({ customerId, title, commitmentLineItems, usageLineItems, measurementChartData, invoiceId }) => {
  return (
    <DynamicInvoiceViewSection
      title={title}
    >
      {[...commitmentLineItems, ...usageLineItems].map((lineItem, index) => (
        <DynamicInvoiceProductLineItem
          key={index}
          invoiceId={invoiceId}
          productLineItem={lineItem}
          customerId={customerId}
          measurementChartData={measurementChartData}
          isOnlyOneProductLineItem={commitmentLineItems.length + usageLineItems.length === 1}
        />
      ))}
    </DynamicInvoiceViewSection>
  );
};